import { usePageNumberFromUrl } from 'idsk-react-components';
import { ClientStatus } from '../../../model/ClientStatus';
import { useClient } from '../../../context/ClientStatusContext';
import { getAktualitaList } from '../../../client/aktualitaListClient';
import AktualitaListPage from '../../../model/AktualitaListPage';

interface ReturnType {
  aktualitaPage: AktualitaListPage;
  status: ClientStatus;
  pageNumberFromUrl: number;
}

export const PER_PAGE_VALUE = 9;

export default (): ReturnType => {
  const { page: pageNumberFromUrl } = usePageNumberFromUrl();

  const {
    data: aktualitaPage,
    status,
  } = useClient(
    () => getAktualitaList(PER_PAGE_VALUE, pageNumberFromUrl),
    [pageNumberFromUrl],
  );

  return <ReturnType>{
    aktualitaPage,
    status,
    pageNumberFromUrl,
  };
};
